import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string>('')

  useEffect(() => {
    const handleCallback = () => {
      const code = searchParams.get('code')
      const errorParam = searchParams.get('error')
      const errorMessage = searchParams.get('message')

      if (errorParam || errorMessage) {
        setError(errorMessage || 'Ověření selhalo')
        return
      }

      if (!code) {
        setError('Nebyl přijat autorizační kód')
        return
      }

      // Redirect to our backend OAuth handler (same origin)
      // The backend will exchange the code for a token and set the cookie
      const state = searchParams.get('state')
      const url = state
        ? `/api/auth/discord/callback?code=${code}&state=${encodeURIComponent(state)}`
        : `/api/auth/discord/callback?code=${code}`

      window.location.href = url
    }

    handleCallback()
  }, [searchParams])

  if (error) {
    return (
      <div className="auth-callback-page">
        <div className="container">
          <div className="error-container">
            <h1>Ověření selhalo</h1>
            <p>{error}</p>
            <button onClick={() => navigate('/login')} className="btn-primary">
              Zpět na přihlášení
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-callback-page">
      <div className="container">
        <div className="loading-container">
          <div className="loader">
            <div className="loader-icon">A</div>
            <div className="loader-text">Ověřování...</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthCallbackPage
